<template>
  <div class="w-full flex flex-col">
    <div class="flex-1 block m-0 md:m-2 p-0 md:p-2 border border-black left fixed w-full sm:w-auto">
      <div class="flex items-center justify-between m-1 p-1">
        <h1 class="text-3xl font-normal leading-normal mt-0 mb-2 m-1 p-1">RSVP Reader</h1>

        <button
            @click="openLegal"
            class="w-8 h-8 rounded-full bg-gray-200 text-gray-700
           flex items-center justify-center
           hover:bg-gray-300 hover:text-black
           focus:outline-none"
            aria-label="About these texts"
        >
          i
        </button>
      </div>

      <div class="block m-1 p-1 flex" v-bind:class="{ hidden: isHidden }">
        <div class="flex-auto">
          {{ wpm }} WPM
        </div>

        <div class="flex-auto">
          {{ timeInterval }} ms interval
        </div>

        <div class="flex-auto">
          {{ wordNumber }}/{{ wordCount }} words
        </div>

        <div class="flex-auto">
          {{ percentage }}%
        </div>

      </div>

      <div class="block m-1 p-1" v-bind:class="{ hidden: isHidden }">
        <select v-model="txtfile" @change="dropdownBook($event)" class="border border-black border-2 p-1 w-full">
          <option v-for="(book, index) in books" :value="book.filename" :key="index">
            {{ book.title }}
          </option>
        </select>
      </div>

      <div class="mt-2 mb-8 p-1 flex w-full">

        <div class="flex-auto" v-bind:class="{ hidden: isHidden }">
          <div class="inline-block">
            <label for="wpm">WPM</label>
            <input type="number" id="wpm" v-model="wpm" @change="convert_wpm_to_ms()" class="w-16 border border-gray-600 ml-1 mr-2 px-1" />
          </div>

          <div class="inline-block">
            <label for="word">WORD</label>
            <input type="number" id="word" v-model="wordNumber" @change="updateBookmark()" class="w-20 border border-gray-600 ml-1 px-1" />
          </div>

        </div>


        <div class="flex-auto flex flex-row" v-bind:class="{ 'justify-center': isHidden }">
          <button @click="clickPlay" v-if="!loading" class="mx-1 px-1"><unicon name="play" height="22" width="22"></unicon></button>
          <button @click="clickPause" v-if="!loading" class="mx-1 px-1"><unicon name="pause" height="22" width="22"></unicon></button>
          <button @click="clickStop" v-if="!loading" class="mx-1 px-1"><unicon name="square" height="20" width="20"></unicon></button>
        </div>

      </div>

      <div class="block absolute bottom-0 left-1">
        <button v-on:click="isHidden = !isHidden">{{ isHidden ? 'expand' : 'min' }}</button>
      </div>

      <div class="block absolute bottom-0 right-1" v-bind:class="{ hidden: isHidden }">
        by <a href="//shortdark.co.uk" rel="noopener" target="_blank" class="underline">shortdark.co.uk</a>
      </div>


    </div>

    <!-- Legal / Info modal -->
    <div
        v-if="showLegal"
        class="fixed inset-0 z-50 flex items-center justify-center"
    >
      <!-- Backdrop -->
      <div
          class="absolute inset-0 bg-black bg-opacity-50"
          @click="closeLegal"
      ></div>

      <!-- Modal box -->
      <div class="relative z-10 max-w-lg w-full mx-4 bg-white border border-black p-4">
        <div class="flex justify-between items-start mb-2">
          <h2 class="text-lg font-semibold">About these texts</h2>
          <button
              @click="closeLegal"
              class="ml-2 border border-black px-2 py-1 text-sm"
              aria-label="Close"
          >
            ✕
          </button>
        </div>

        <p class="mb-2 text-sm">
          This book is provided from Project Gutenberg, a volunteer-driven digital
          library that makes books freely available in electronic form. Most Project
          Gutenberg texts are in the public domain in the United States, or are
          shared with permission under specific licence terms.
        </p>

        <p class="mb-2 text-sm">
          You may read, copy, and share these texts for personal, educational, and
          non-commercial use. Commercial redistribution or charging for access is
          not permitted. Project Gutenberg provides these works “as is” without
          warranty. Full licence details and copyright information are available on
          the
          <a
              href="https://www.gutenberg.org"
              target="_blank"
              rel="noopener"
              class="underline"
          >
            Project Gutenberg website
          </a>.
        </p>
      </div>
    </div>


    <div class="flex h-screen">
      <div class="m-auto overflow-hidden">
        <div class="text-6xl leading-normal">{{ selectedWord }}</div>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      books: [],
      txtfile: '',
      dbook: '',
      bookArray: [],
      wordCount: 0,
      selectedWord: '',
      play: false,
      wordNumber: 0,
      wpm: 200,
      timeInterval: 0,
      timer: '',
      loading: true,
      percentage: 0,
      domain: 'https://books.rsvpreader.com',
      isHidden: false,
      showLegal: false,
    }
  },
  methods: {
    async init() {
      try {
        const response = await fetch(this.domain + '/manifest.json')
        this.books = await response.json()
        this.txtfile = this.books?.[0]?.filename || ''
        if (this.txtfile) {
          this.displayBook()
        }
      } catch (e) {
        console.error('Could not load manifest:', e)
      }
    },
    dropdownBook() {
      this.wordNumber = 0
      this.wordCount = 0
      this.loading = true
      this.percentage = 0
      this.selectedWord = ''
      this.play = false
      this.displayBook()
    },
    displayBook() {
      this.axios
          .get(this.domain + '/books/' + this.txtfile)
          .then((response)=>{
            this.dbook = response.data
            this.dbook = this.dbook.replace(/\n/g, ' ')
                .replace(/\s\s+/g, ' ');
            this.bookArray = this.dbook.trim().split(" ");
            this.bookArray = [''].concat(this.bookArray);
            this.wordCount = this.bookArray.length;
            this.loading = false
            this.convert_wpm_to_ms();
            this.startTimer();
          }).catch(error => console.error(error));
    },
    convert_wpm_to_ms(){
      this.timeInterval = 60000 / this.wpm;
      clearInterval(this.timer);
      this.startTimer();
    },
    startTimer() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (this.play === true) {
          this.wordNumber++;
          this.selectedWord = this.bookArray[this.wordNumber];
          this.percentage = ((this.wordNumber / this.wordCount) * 100).toFixed(2);
        }
      },this.timeInterval);
    },
    updateBookmark() {
      this.selectedWord = this.bookArray[this.wordNumber];
      this.percentage = ((this.wordNumber / this.wordCount) * 100).toFixed(2);
    },
    clickPlay() {
      this.play = true
      if (this.play === true) {
        this.startTimer();
      }
    },
    clickPause() {
      this.play = false
      clearInterval(this.timer);
    },
    clickStop() {
      this.play = false
      this.wordNumber = 0
      this.selectedWord = this.bookArray[this.wordNumber];
      this.percentage = 0
      clearInterval(this.timer);
    },
    openLegal() {
      // Pause if currently playing
      if (this.play === true) {
        this.clickPause();
      }
      this.showLegal = true;
    },
    closeLegal() {
      this.showLegal = false;
    },
  },
  mounted() {
    this.init()
  }
}
</script>
